import { Company, Client, Request } from 'Types';

export const selectClient = (
  clients: Company[],
  request?: Request,
  update?: boolean,
  view?: boolean,
  duplicate?: boolean,
): Client | undefined => {
  const clientsFiltered = clients
    .flatMap((client) =>
      client.accounts.map((account) => ({
        id: client.id,
        name: client.name,
        label: `${client.name} (${
          account.codeTiers.startsWith('$') ? 'Prospect' : account.codeTiers
        })`,
        accountId: account.id,
        emails: client.users
          .filter(({ isActive }) => isActive || view || update)
          .map(({ email }) => email),
      })),
    )
    .filter((c) => c.emails.length > 0);

  return clientsFiltered.find(
    (c) =>
      request &&
      !duplicate &&
      c.id == request.company.id &&
      c.accountId == request.account.id,
  );
};
